module.exports = "https://www.niulinkcloud.com/_next/static/media/mobileBanner.d38e256a8efea55e21972be863450f92.png";